import { AccountingRoles, GlobalRoles, IUser } from '@monorepo/interfaces';

export const hasRole = (
    user: IUser | undefined,
    userRole: GlobalRoles | GlobalRoles[] | AccountingRoles | AccountingRoles[]
): boolean => {
    const roles = user?.permissions.map(permission => permission.role);
    if (Array.isArray(userRole)) {
        return userRole.some(role => roles?.includes(role));
    } else if (roles) {
        return roles.includes(userRole);
    } else {
        return false;
    }
};
